export enum ProductStatus {
    ToOrdered = 0,
    Available = 1,
    Discontinued = 2,
}